import useOrgUnitOmeMeetEntryTreeView from './UseOrgUnitOmeMeetEntryTreeView';

import TreeView from '@usas/ui-web/components/tree/TreeView';

import Constants from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const OrgUnitOmeMeetEntryTreeView = ({ label, name, value, error, message, selectableLeavesOnly, singleSelect,
  onChange, omeMeetId, omeMeetEntryId }) => {
  const { orgUnitOmeMeetEntryState } = useOrgUnitOmeMeetEntryTreeView(omeMeetId || Constants.DEFAULT_ID, omeMeetEntryId || Constants.DEFAULT_ID);

  return orgUnitOmeMeetEntryState.message
    ? <span className={global.LoadingMsg}>{orgUnitOmeMeetEntryState.message}</span>
    : <TreeView
      label={label}
      name={name}
      value={value}
      error={error}
      message={message}
      isLoading={orgUnitOmeMeetEntryState.isArrayLoading}
      options={orgUnitOmeMeetEntryState.treeData}
      selectableLeavesOnly={selectableLeavesOnly}
      singleSelect={singleSelect}
      onChange={onChange} />
};

export default OrgUnitOmeMeetEntryTreeView;